module.exports = __webpack_public_path__ + "img/broadcast-tiao-icon1.0c80bfef.png";